import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { resolvePostAuthDestination } from "@/lib/auth";

export default function Callback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const code = searchParams.get("code");
    if (!code) {
      setError("Aucun code de connexion n'a été trouvé dans le lien.");
      return;
    }

    supabase.auth.exchangeCodeForSession(code).then(({ error: err }) => {
      if (err) {
        setError(err.message);
        return;
      }
      const next = searchParams.get("next");
      if (next === "/auth/reset-password") {
        navigate("/auth/reset-password", { replace: true });
      } else {
        navigate(resolvePostAuthDestination(next), { replace: true });
      }
    });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        {error ? (
          <>
            <i className="ri-error-warning-line text-4xl text-primary-500"></i>
            <p className="mt-4 text-sm text-foreground-700">{error}</p>
            <a
              href="/auth/login"
              className="mt-4 inline-block text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              Retour à la connexion
            </a>
          </>
        ) : (
          <>
            <i className="ri-loader-4-line animate-spin text-4xl text-primary-500"></i>
            <p className="mt-4 text-sm text-foreground-600">
              Connexion en cours…
            </p>
          </>
        )}
      </div>
    </div>
  );
}